"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var paymentRatesStyles = makeStyles_1.default(function (_a) {
    var _b = _a.typography, fontFamily2 = _b.fontFamily2, fontMD = _b.fontMD, fontXS = _b.fontXS, fontXL = _b.fontXL, palette = _a.palette;
    return ({
        container: {
            margin: '16px 0',
        },
        title: {
            color: palette.common.black,
            fontWeight: 600,
        },
        repaymentDuration: {
            marginLeft: 6,
            fontSize: fontMD,
            fontWeight: 500,
            color: palette.primary.main,
        },
        paymentRatesContainer: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
        },
        paymentRatesGridRoot: {
            width: '100%',
        },
        summaryRoot: {
            padding: 10,
            background: palette.background.alternate,
            color: palette.primary.main,
        },
        paymentRatesPercentageGroup: {
            margin: '10px 0 0',
        },
        paymentRatesPercentageValue: {
            fontFamily: fontFamily2,
            fontSize: fontXL,
            color: palette.common.black,
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
        },
        paymentRatesPercentageLabel: {
            fontSize: fontXS,
            color: palette.common.black,
            paddingBottom: 0,
        },
        comparisonRate: {
            borderLeft: "1px solid " + palette.divider,
            paddingLeft: 15,
        },
        rpaLabel: {
            marginLeft: 6,
        },
    });
}, { name: 'GqlSummary_RepaymentRates' });
exports.default = paymentRatesStyles;
